import axios from "~/plugins/axios";

export default {
  getById(countryId) {
    return axios.get(`/web_api/v1/country/${countryId}`).then((response) => response.data);
  },
  all() {
    return axios.get("/web_api/v1/country", {
      params: {
        perPage: 300,
      },
    }).then((response) => response.data);
  },
};
